export const environment = {
   apiBaseUrl: 'api.sriganesar.easyplore.com',
   apiVersion: '/api/v1',
   production: false,
};
